/* eslint-disable no-undef */
import Cohere from 'cohere-js';

import SETTINGS from '../../settings';

const TAG = 'Cohere';

const CohereScript = {
  init() {
    try {
      Cohere.init(SETTINGS.SCRIPTS.COHERE_ID);
    } catch (e) {
      console.log(TAG, 'init', e);
    }
  },

  identify(userId, email, name) {
    try {
      Cohere.identify(`${userId}`, {
        email: email || undefined,
        displayName: name || undefined,
      });
    } catch (e) {
      console.log(TAG, 'identify', e);
    }
  },
};

export default CohereScript;
